/**
 * The FAQ questions and answers.
 *
 * Extracted from FAQ.jsx so two consumers can share one list: the page that
 * renders them, and scripts/prerender-seo.mjs, which bakes them into a
 * schema.org FAQPage block in the static HTML. Duplicating them would mean the
 * rich result could silently disagree with the page — the kind of mismatch
 * that surfaces as a Search Console warning months later.
 *
 * FAQPage is the highest-value schema this product has: the questions are real
 * objections ("Does NextOpp invent experience?"), and AI summarizers parse a
 * question/answer pair far more reliably than the same content as prose.
 */
export const FAQ_SECTIONS = [
  {
    heading: "Honesty & trust",
    items: [
      ["Does NextOpp invent experience to boost my score?", "Never. Our AI is built to rephrase, reorder, and emphasize your real background only. It will not add companies, degrees, certifications, job titles, dates, metrics, or skills you don’t have. If a job needs something you’re missing, we flag it as a recommendation — we don’t fake it."],
      ["Is this an auto-apply bot?", "No. NextOpp is human-in-the-loop by design. You review and approve every resume, cover letter, and application. The optional browser helper can autofill forms, but it never submits an application for you."],
      ["Will recruiters be able to tell I used AI?", "Tailored resumes and cover letters read like you wrote them, because they’re grounded in your real experience and your approval. There’s no generic AI filler, and you edit anything before it goes out."],
    ],
  },
  {
    heading: "How it works",
    items: [
      ["What file types can I upload?", "PDF and DOCX. We extract the text and structure it into editable sections you can review and correct."],
      ["How does the ATS match score work?", "We extract required and preferred skills from the job description, compare them to your resume, and return a 0–100 score with matching keywords, missing keywords, and concrete recommendations."],
      ["Can I edit the AI’s suggestions?", "Always. Every tailored bullet has a before/after view with accept, reject, or edit. Nothing is final until you say so."],
    ],
  },
  {
    heading: "Plans & billing",
    items: [
      ["Is there a free plan?", "Yes. Free includes 1 base resume, 5 tailored resumes, 5 cover letters, and 5 board refreshes per month, plus the full pipeline tracker — no card required."],
      ["What do paid plans add?", "Pro ($19/mo) removes the monthly caps and adds priority AI, follow-up reminders, interview prep, and company research. Career Pro ($39/mo) adds advanced job ranking, recruiter templates, salary-negotiation prep, premium templates, and version history. Coach / Team ($99/mo) adds a coach dashboard, shared templates, team analytics, and white-label PDFs."],
      ["Can I cancel anytime?", "Yes. You keep access through the end of your billing period, and your data stays yours."],
    ],
  },
  {
    heading: "Privacy",
    items: [
      ["Where is my resume stored?", "Privately. Resumes are never given public URLs and are only accessible to you. See our Security page for details."],
      ["Can I delete my data?", "Yes. You can delete individual resumes or your entire account, which removes your personal data. See the Privacy page."],
    ],
  },
];

/** Flat [question, answer] pairs, which is what FAQPage wants. */
export const FAQ_PAIRS = FAQ_SECTIONS.flatMap((s) => s.items);
